const Key = Symbol('Steps');

export default Key;
